
import { assetDetailsUrl ,getAssetCurrencyTypeAPI,updateCustomSettings } from "../../config/apiConfig";
import { updateEntity } from "../CommonAPI";
import {
  FETCH_ASSET_BEGIN,
  FETCH_ASSET_SUCCESS,
  FETCH_ASSET_FAILURE,
  FETCH_ASSET_CURRENCYTYPE_BEGIN,
  FETCH_ASSET_CURRENCYTYPE_SUCCESS,
  FETCH_ASSET_CURRENCYTYPE_FAILURE,

} from '../constants/assets';
import { sbaAxios } from "../utils/sbaAxios";


export const getAsset = (assetID) => {
  return (dispatch) => {
    dispatch(fetchAssetBegin());
    sbaAxios({
      url: `${assetDetailsUrl}${assetID}`,
      method: 'get',
    })
      .then(response => {
        const Asset = response;
        dispatch(fetchAssetSuccess(Asset));
        updateEntity("AssetId",assetID);
        return Asset;
      })
      .catch((error) => {
        dispatch(fetchAssetFailure(error?.response?.status));
        console.log(error);
      });     
  };
}

export const fetchAssetBegin = () => ({
  type: FETCH_ASSET_BEGIN,
});

export const fetchAssetSuccess = (assetDataItem) => ({
  type: FETCH_ASSET_SUCCESS,
  payload: { assetDataItem },
});


export const fetchAssetFailure = (errorcode) => ({
  type: FETCH_ASSET_FAILURE,
  payload: { errorcode }
});

export const getAssetCurrencyType=(assetID)=>{
  return (dispatch) => {
    dispatch(fetchAssetCurrencyTypeBegin());
    sbaAxios({
        url: `${getAssetCurrencyTypeAPI}${assetID}`,
        method: 'get',
    })
        .then((repos) => {
            const currencyType = repos;
            dispatch(fetchAssetCurrencyTypeSuccess(currencyType));
            return currencyType;
        })
        .catch((error) => dispatch(fetchAssetCurrencyTypeFailure(error)));
};
};
export const fetchAssetCurrencyTypeBegin = () => ({
  type: FETCH_ASSET_CURRENCYTYPE_BEGIN,
});

export const fetchAssetCurrencyTypeSuccess = (currencyType) => ({
  type: FETCH_ASSET_CURRENCYTYPE_SUCCESS,
  payload: { currencyType },
});


export const fetchAssetCurrencyTypeFailure = (errorMessage) => ({
  type: FETCH_ASSET_CURRENCYTYPE_FAILURE,
  payload: { errorMessage }
});

